<div class="d-flex justify-content-between align-items-center w-100">
  <div class="w-100"></div>
  <div class="pagination-left w-100">
    <app-pagination *ngIf="totalSuppliersRowsCount > 100" [totalItems]="totalSuppliersRowsCount" [(currentPage)]="currentSupplierPageNumber"
      (change)="onPageChange($event)" [pageSize]="100"></app-pagination>
  </div>

  <div class="d-flex align-items-center justify-content-end w-100">
    <span class="pagination-count">Showing {{ getSupplierCount() }} of {{ totalSuppliersRowsCount }} results</span>
  </div>
</div>
